const clientId = process.env.VUE_APP_GOOGLE_CLIENT_ID

let initialized = false
let currentCallback = null

function ensureInitialized() {
  if (initialized) return
  if (!window.google || !window.google.accounts || !window.google.accounts.id) {
    throw new Error('Google Identity Services não carregado')
  }
  if (!clientId) {
    throw new Error('VUE_APP_GOOGLE_CLIENT_ID não configurado')
  }

  window.google.accounts.id.initialize({
    client_id: clientId,
    callback: (response) => {
      if (currentCallback && response && response.credential) {
        currentCallback(response.credential)
      }
    },
  })

  initialized = true
}

export function waitForGoogleScript(timeoutMs = 5000) {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.accounts && window.google.accounts.id) {
      resolve()
      return
    }
    const start = Date.now()
    const interval = setInterval(() => {
      if (window.google && window.google.accounts && window.google.accounts.id) {
        clearInterval(interval)
        resolve()
      } else if (Date.now() - start > timeoutMs) {
        clearInterval(interval)
        reject(new Error('Timeout aguardando Google Identity Services'))
      }
    }, 100)
  })
}

export function renderGoogleButton(element, onCredential, options = {}) {
  ensureInitialized()
  currentCallback = onCredential
  window.google.accounts.id.renderButton(element, {
    theme: 'outline',
    size: 'large',
    type: 'standard',
    text: 'signin_with',
    shape: 'rectangular',
    logo_alignment: 'left',
    locale: 'pt-BR',
    width: 400,
    ...options,
  })
}
